/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconDoubled: {
  name: 'doubled';
  data: string;
} = {
  name: 'doubled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M311.219 112.208c-20.853 0-25.557 30.891-4.968 30.891 6.876 0 6.929-10.31 0-10.31-11.152.001-7.899-16.167 4.968-20.581zm-2.465 7.359c-6.876 0-6.929 10.31 0 10.31 11.152 0 7.041 16.168-5.827 20.582 20.853-.001 26.415-30.892 5.827-30.892z" transform="matrix(15 0 0 15 -4303.917 -1664)"/></svg>`,
};
